export enum AuthMode {

  login,
  signUp

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/authMode.ts